export default __webpack_public_path__ + "static/media/CV.5ff673e3.svg";